import { z } from "zod";

const closingStatuses = [
	"ClosingRequired",
	"Closing",
	"Closed",
	"ClosingFailed",
	"ClosedManually",
	"ClosingRemoved",
] as const;
export const closingStatusSchema = z.enum(closingStatuses);
export type ClosingStatus = z.infer<typeof closingStatusSchema>;

export const closingCartonSchema = z.object({
	closingId: z.string(),
	packagingSolutionId: z.string(),
	alias: z.string(),
	closingMachineId: z.string().nullish(),
	upstreamCompletedDateUTC: z.coerce.date(),
	startedClosingDateUTC: z.coerce.date().nullish(),
	lastFailedClosingDateUTC: z.coerce.date().nullish(),
	status: closingStatusSchema,
	identifier: z.string().nullish(), // can remove nullish when production service is enforcing non-null
	failureReason: z.string().nullish(),
});

export const closingCartonsResponseSchema = z.object({
	results: z.array(closingCartonSchema),
	totalResults: z.number(),
});

export const closedTodayResponseSchema = z.object({
	closedToday: z.number(),
});

export const closingAnalyticsResponseSchema = z.object({
	awaitingClosingCount: z.number(),
	failedClosingCount: z.number(),
	averageTimeToClose: z.string(),
	oldestOutstandingClosingDateUTC: z.coerce.date().nullable(),
});

const closingScanFailedReason = [
	"NoMatches",
	"MultipleMatches",
	"NoProductionOptionsForMachine",
	"InvalidDataForResponse",
	"ClosingRemoved",
] as const;
export const closingScanFailedReasonSchema = z.enum(closingScanFailedReason);
export type ClosingScanFailedReason = z.infer<typeof closingScanFailedReasonSchema>;

export const closingScanFailedSchema = z.object({
	id: z.string(),
	closingId: z.string().nullable(),
	internalUniqueId: z.string().nullable(),
	batchId: z.string().nullable(),
	alias: z.string().nullable(),
	tenantId: z.string(),
	machineId: z.string(),
	scannedIdentifier: z.string(),
	failureReason: closingScanFailedReasonSchema,
	eventUtcTimeStamp: z.coerce.date(),
});

export const closingScanFailedResponseSchema = z.object({
	items: z.array(closingScanFailedSchema),
	totalCount: z.number(),
	pageNumber: z.number(),
	pageSize: z.number(),
});

export type ClosingCarton = z.infer<typeof closingCartonSchema>;
export type ClosingCartonsResponse = z.infer<typeof closingCartonsResponseSchema>;
export type ClosedTodayResponse = z.infer<typeof closedTodayResponseSchema>;
export type ClosingAnalyticsResponse = z.infer<typeof closingAnalyticsResponseSchema>;
export type ClosingScanFailed = z.infer<typeof closingScanFailedSchema>;
export type ClosingScanFailedResponse = z.infer<typeof closingScanFailedResponseSchema>;
